module.exports = __webpack_public_path__ + "img/fi-rr-flip-horizontal.8c9185b2.svg";